export default function Precio() {
  return (
    <section id="precio" className="relative bg-[#0a0a0a] py-20 md:py-32 px-4 overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] md:w-[800px] md:h-[800px] rounded-full bg-[#8b5cf6]/8 blur-[120px]" />
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#8b5cf6]/30 to-transparent" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto">

        {/* Persuasive text */}
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block bg-[#ec4899]/10 border border-[#ec4899]/30 text-[#f9a8d4] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            La oferta que no puedes ignorar
          </span>
          <p className="text-gray-300 text-base md:text-xl leading-relaxed max-w-2xl mx-auto">
            Lo mejor de todo es esto. El precio{' '}
            <span className="text-white font-bold">NO es de S/ 100.00</span> ni de{' '}
            <span className="text-white font-bold">S/ 50.00</span>. Solo por hoy, y como una{' '}
            <span className="bg-gradient-to-r from-[#8b5cf6] to-[#ec4899] bg-clip-text text-transparent font-bold">
              promoción única para nuestra comunidad élite...
            </span>
          </p>
        </div>

        {/* Price Box */}
        <div
          className="relative rounded-[32px] md:rounded-[40px] p-[2px] mb-8 md:mb-10"
          style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 50%, #10b981 100%)',
            animation: 'priceGlow 3s ease-in-out infinite',
          }}
        >
          <div className="bg-[#0d0d0d] rounded-[30px] md:rounded-[36px] px-5 md:px-12 py-10 md:py-16 text-center">

            {/* Old price */}
            <div className="mb-4 flex flex-wrap items-center justify-center gap-2">
              <span className="text-gray-500 text-xl md:text-3xl font-bold line-through decoration-2">
                S/ 100.00
              </span>
              <span className="bg-red-500/20 border border-red-500/40 text-red-400 text-xs font-bold px-3 py-1 rounded-full">
                -90% OFF
              </span>
            </div>

            {/* Divider */}
            <div className="flex items-center justify-center mb-5 md:mb-6">
              <div className="h-px w-16 md:w-32 bg-gradient-to-r from-transparent via-[#8b5cf6] to-transparent" />
              <span className="mx-3 md:mx-4 text-[#8b5cf6] text-xs md:text-sm font-bold">HOY PAGAS</span>
              <div className="h-px w-16 md:w-32 bg-gradient-to-r from-[#8b5cf6] to-transparent" />
            </div>

            {/* Current price */}
            <div className="mb-6">
              <div className="inline-block bg-[#0a0a0a] border border-[#8b5cf6]/30 rounded-2xl md:rounded-3xl px-6 md:px-8 py-4 md:py-6">
                <p className="text-gray-400 text-xs md:text-sm mb-2">🔥 Precio especial 🔥</p>
                <p
                  className="font-black leading-none bg-gradient-to-r from-[#8b5cf6] via-[#ec4899] to-[#10b981] bg-clip-text text-transparent"
                  style={{ fontSize: 'clamp(52px, 15vw, 96px)' }}
                >
                  S/ 10
                </p>
                <p className="text-white font-bold text-base md:text-xl mt-2">.00 (Diez Soles)</p>
              </div>
            </div>

            {/* Guarantee badge */}
            <div className="inline-flex flex-wrap items-center justify-center gap-2 bg-[#10b981]/10 border border-[#10b981]/40 text-[#10b981] font-bold text-xs md:text-sm px-4 md:px-6 py-2 md:py-3 rounded-full mb-7 md:mb-8 text-center leading-snug">
              <i className="ri-shield-check-line text-base w-4 h-4 flex items-center justify-center"></i>
              <span>Pago único anual — No se repite.</span>
              <span>Un solo acceso por 1 año.</span>
            </div>

            {/* What's included summary */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3 mb-8 md:mb-10 text-left">
              {[
                { icon: '🤖', text: 'ChatGPT Plus' },
                { icon: '🎬', text: 'CapCut PRO' },
                { icon: '🎥', text: 'Filmora PRO' },
                { icon: '📚', text: 'Curso de IA' },
                { icon: '🎨', text: 'Plantillas Canva' },
                { icon: '✨', text: 'Canva PRO' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 bg-[#1f2937]/60 rounded-xl px-2 md:px-3 py-2 md:py-2.5">
                  <span className="text-base md:text-lg">{item.icon}</span>
                  <span className="text-gray-300 text-xs md:text-sm font-medium">{item.text}</span>
                </div>
              ))}
            </div>

            {/* CTA Button — 2 lines on mobile */}
            <a
              href="https://wa.link/mbtq6u"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 bg-gradient-to-r from-[#8b5cf6] via-[#ec4899] to-[#10b981] text-white font-black text-base md:text-xl px-6 md:px-10 py-4 md:py-5 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 w-full max-w-lg mx-auto text-center leading-snug"
              style={{ animation: 'ctaPulse 1.5s ease-in-out infinite' }}
            >
              <span className="text-lg">⚡</span>
              <span>
                ¡COMPRAR AHORA
                <br className="sm:hidden" />
                {' '}POR S/ 10.00!
              </span>
              <span className="hidden sm:inline group-hover:translate-x-1 transition-transform duration-200">→</span>
            </a>

            <p className="text-gray-600 text-xs mt-4">
              🔒 Pago 100% seguro · Acceso inmediato · Sin suscripción
            </p>
          </div>
        </div>

        {/* Closing phrase */}
        <div className="bg-[#111827] border-l-4 border-[#8b5cf6] rounded-2xl px-5 md:px-8 py-5 md:py-8">
          <p className="text-gray-200 text-sm md:text-lg leading-relaxed">
            Es literalmente menos de lo que te cuesta un{' '}
            <span className="text-white font-bold">🍔 combo de comida rápida</span> por herramientas que{' '}
            <span className="bg-gradient-to-r from-[#8b5cf6] to-[#10b981] bg-clip-text text-transparent font-bold">
              multiplicarán tus ingresos
            </span>
            . Tú decides si{' '}
            <span className="text-gray-400">comes hoy</span> o{' '}
            <span className="text-[#10b981] font-bold">💰 facturas mañana</span>.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes priceGlow {
          0%, 100% { box-shadow: 0 0 40px rgba(139,92,246,0.4), 0 0 80px rgba(236,72,153,0.2); }
          50% { box-shadow: 0 0 80px rgba(139,92,246,0.7), 0 0 120px rgba(236,72,153,0.4), 0 0 160px rgba(16,185,129,0.2); }
        }
        @keyframes ctaPulse {
          0%, 100% { box-shadow: 0 0 20px rgba(139,92,246,0.5); }
          50% { box-shadow: 0 0 50px rgba(139,92,246,0.8), 0 0 80px rgba(236,72,153,0.4); }
        }
      `}</style>
    </section>
  );
}
